<!-- 全景图 -->
<template>
<div class='panorama'>
    <i-aside></i-aside>
    <iframe id="iframeContainer" :src="link"></iframe>
    <!-- <div class="goIndex"  @click="$router.push({path:'/'})"><img src="../../assets/img/detail-index.png" alt=""></div>
    <div class="goBack" @click="$router.push({path:'/scene'})"><img src="../../assets/img/detail-back.png" alt=""></div> -->
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import aside from '../layout/aside.vue'
export default {
//import引入的组件需要注入到对象中才能使用
inject:['reload'],
components: {
    'i-aside':aside
},
data() {
//这里存放数据
return {
    
    id:'',
    link:'./vtour/tour2.html',
    show:false
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    id() {
        this.id = this.$route.query.id
    },
    show() {
        if(this.id=='start'){
            this.show = false;
        }else {
            this.show = true
        }
    }
},
//方法集合
methods: {
    getRouteData() {
        this.id=this.$route.query.id;
        console.log(this.id)
    },
    goIframe() {
        this.$router.push({path:'/panorama?id=start'});
        this.reload();
    },
    updatePage() {
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    this.getRouteData();
    this.pano.forEach(item => {
        console.log(this.pano)
        if(item.name== this.id){
            this.link = item.link;
        }
    })
    this.id = this.$route.query.id;
    if(this.id == 'topic' || this.id == 'life') {
        this.show = true;
    }
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.panorama {
    width:100%;
    height:100%;
    iframe {
        width:100%;
        height:100%;
    }
    .goIndex {
        position:absolute;
        top:26px;
        right:80px;
    }
    .goBack {
        position:absolute;
        top:26px;
        right:218px;
    }
}

</style>